import { render, staticRenderFns } from "./ListDiseasesBrain.vue?vue&type=template&id=9de39f74&scoped=true"
import script from "./ListDiseasesBrain.vue?vue&type=script&lang=js"
export * from "./ListDiseasesBrain.vue?vue&type=script&lang=js"
import style0 from "./ListDiseasesBrain.vue?vue&type=style&index=0&id=9de39f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de39f74",
  null
  
)

export default component.exports